module.exports = __webpack_public_path__ + "img/insec_child rights.1d5ee8cf.svg";